import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-2/3 flex flex-col ml-[50px]" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-lg text-gary-text-color mb-[30px]" }, " 變更密碼 ", -1)
const _hoisted_3 = { class: "grow flex flex-col mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Password = _resolveComponent("Password")!
  const _component_Btn = _resolveComponent("Btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Password, {
        label: '原有密碼',
        class: "under-line mb-5",
        width: '250px',
        placeholder: "輸入8~12碼英數字",
        modelValue: _ctx.currentPassword,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPassword) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_Password, {
        label: '新密碼',
        class: "under-line mb-5",
        width: '250px',
        placeholder: "輸入8~12碼英數字",
        modelValue: _ctx.newPassword,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newPassword) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_Password, {
        label: '再次輸入新密碼',
        class: "under-line mb-5",
        width: '250px',
        placeholder: "輸入8~12碼英數字",
        modelValue: _ctx.confirmNewPassword,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.confirmNewPassword) = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_Btn, {
        class: "mt-[144px]",
        text: '更新',
        height: '36px',
        width: '121px',
        onClick: _ctx.changePassword
      }, null, 8, ["onClick"])
    ])
  ]))
}